import ActiveRecord from './active_record/base'

class AuthorizedDevice extends ActiveRecord {
	static tableName = 'authorizedDevices'
	static defaultJoins = ['environments']
}

export default AuthorizedDevice
